import { render, staticRenderFns } from "./PlayerBase.vue?vue&type=template&id=df9b85c8"
import script from "./PlayerBase.vue?vue&type=script&lang=ts"
export * from "./PlayerBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports